import { render, staticRenderFns } from "./VaCollapse.vue?vue&type=template&id=063b428e&"
import script from "./VaCollapse.vue?vue&type=script&lang=js&"
export * from "./VaCollapse.vue?vue&type=script&lang=js&"
import style0 from "./VaCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports